<template>
  <BasicModalWindow
    ref="modal_element"
    class="small-window folders-delete"
    :title="modal_title"
    :gtm="{
      module : 'folders',
      feature: 'folders_delete_modal',
      block  : 'modal_header',
      action : 'cancel'
    }"
  >
      <template #body>
          <p v-if="folder_childs.length === 0">
            <strong>{{Language.say('folders.delete.confirmation_one', [selected_folder.name])}}</strong>
          </p>
          <p v-else>
            <strong>{{Language.say('folders.delete.confirmation_sub', [selected_folder.name])}}</strong>
          </p>

          <p>
            {{Language.say('folders.delete.confirmation_reversible')}}
          </p>

          <ul v-if="folder_childs.length > 0">
              <li class="depth-0">{{selected_folder.name}}</li>
              <li v-for="folder in folder_childs" :key=folder.id :class="'depth-' + (folder.level - selected_folder.level)">{{folder.name}}
              </li>
          </ul>
      </template>

      <template #footer>
          <ActionButton
            @click="onClose()"
            text="folders.empty.cancel"
              :gtm="{
                module : 'folders',
                feature: 'folders_delete_modal',
                block  : 'modal_footer',
                action : 'cancel'
              }"
          />
          <ActionButton
            @click="onDeleteFolder()"
            class='danger push-right'
            text="folders.empty.confirm"
            :loading="folders_controller.saving_state.saving[selected_folder.id]"
            :gtm="{
              module : 'folders',
              feature: 'folders_delete_modal',
              block  : 'modal_footer',
              action : 'submit'
            }"
          />
      </template>
  </BasicModalWindow>
</template>

<script setup>
  import { defineProps, onBeforeMount, ref } from 'vue';
  import BasicModalWindow                    from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                        from '@/vue/Elements/Buttons/ActionButton.vue'
  import FoldersController                   from '@/js/Mailboxes/FoldersController';
  import Language                            from '@/js/Shared/Language/Language.js';

  const props   = defineProps({
    selected_folder : {
      required: true,
    }
  })

  const folders_controller = FoldersController;
  const modal_element      = ref();
  const folder_childs      = ref();
  const modal_title        = Language.say('folders.delete.title', [props.selected_folder.name]);

  onBeforeMount(() => {
    folder_childs.value = folders_controller.mailboxes.folders.all.getChilds(props.selected_folder);
  })

  const onDeleteFolder = async () => {
    let success = await folders_controller.delete(props.selected_folder);

    if (success) {
      close();
    }
  }

  const onClose = () => {
    close();
  }

  const close = () => {
    modal_element.value.close();
  }
</script>
